import { render } from "./ButtonToolbar.vue?vue&type=template&id=0572fbb8&scoped=true"
import script from "./ButtonToolbar.vue?vue&type=script&lang=js"
export * from "./ButtonToolbar.vue?vue&type=script&lang=js"

import "./ButtonToolbar.vue?vue&type=style&index=0&id=0572fbb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0572fbb8"]])

export default __exports__